<script>

import { TreeMenu } from 'vue-instantsearch'

export default {
  extends: TreeMenu,
  data() {
    return {
      blockClassName: 'ais-tree-menu',
      facetSearch: '',
    };
  },
  computed: {
    facetValues() {
      let patt = new RegExp('(' + this.facetSearch + ').*', 'gi')

      const values = this.searchStore.getFacetValues(
        this.attribute,
        this.sortBy
      )
      // return values.data && values.data.filter(x => this.facetSearch ? patt.exec(x.name) : x).slice(0, 10000) || [];
      return values.data || [];
    },
  },
  methods: {
    clearFacetSearch () {
      this.facetSearch = ''
    },
    _renderList (h, facetValues, isRoot = true) {
      const listItems = []
      for (const facet of facetValues) {
        const listItemLabel = []
        let count = facet.count -1
        if (this.$scopedSlots.default) {
          listItemLabel.push(
            this.$scopedSlots.default({
              value: facet.name,
              count: facet.count,
              active: facet.isRefined
            })
          )
        } else {
          listItemLabel.push(
            h(
              'span',
              {
                class: this.bem('value')
              },
              facet.name
            ),
            h(
              'span',
              {
                class: this.bem('count')
              },
              count > 0 && ' (' + count + ')' || ''
            )
          )
        }

        const listItemChildren = [
          h(
            'a',
            {
              domProps: {
                href: '#'
              },
              on: {
                click: event => {
                  event.preventDefault()
                  this.toggleRefinement(facet)
                }
              }
            },
            listItemLabel
          )
        ]

        if (facet.isRefined && facet.data && facet.data.length > 0) {
          listItemChildren.push(this._renderList(h, facet.data, false))
        }

        listItems.push(
          h(
            'li',
            {
              class: [
                this.bem('item'),
                facet.isRefined ? this.bem('item', 'active') : ''
              ]
            },
            listItemChildren
          )
        )
      }
      return h(
        'ul',
        {
          class: isRoot ? this.bem('list') : ''
        },
        listItems
      )
    }
    
  },
  watch: {
    facetSearch: function(val) {
      console.log('...w')
      this.$emit('input', val);
    }
  },
  render (h) {
    const children = []

    if (this.$slots.header) {
      children.push(this.$slots.header)
    }
    // var self = this
    // children.push(h(
    //   'v-text-field',
    //     {
    //       domProps: {
    //         value: self.facetSearch
    //       },
    //       on: {
    //         input: function (event) {
    //           console.log('...')
    //           self.$emit('input', event)
    //           console.log(self.facetValues)
    //         },
    //         'click:clear': this.clearFacetSearch,
    //       },
    //       class: 'searchInput',
    //       style: {
    //         width: '250px'
    //       },
    //       attrs: {
    //         placeholder: 'Search',
    //         clearable: true,
    //       }
    //     }
    //   ))

    if (this.show === false) {
      children.push(h(
        'div',
        {
          class: 'no-result'
        },
        'No result'
      ))
    } else {
      children.push(this._renderList(h, this.facetValues))
    }

    if (this.$slots.footer) {
      children.push(this.$slots.footer)
    }

    return h(
      'div',
      {
        class: this.bem()
      },
      children
    )
  }
}
</script>
<style>

.ais-tree-menu {
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 10px;
}
.ais-tree-menu .no-result {
  color: rgba(0, 0, 0, 0.63);
  padding: 5px 0px 5px;
  margin-bottom: 3px;
  background-color: #fafafa;
  max-width: 98%;
}
.ais-tree-menu__item {
  background-color: #fafafa;
  max-width: 98%;
}
.ais-tree-menu span {
  font-size: 16px;
}
.ais-tree-menu__list {
  max-height: 250px;
  overflow: auto;
}

</style>
